import { render } from "./ApplicantList.vue?vue&type=template&id=6428d1fa&scoped=true"
import script from "./ApplicantList.vue?vue&type=script&lang=js"
export * from "./ApplicantList.vue?vue&type=script&lang=js"

import "./ApplicantList.vue?vue&type=style&index=0&id=6428d1fa&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6428d1fa"]])

export default __exports__